import React from "react";
import RGL, { WidthProvider } from "react-grid-layout";

import {check} from "../icons";
import {getLayout} from "../helper/layouts";
import {ITemplateConfig} from "../../../constants/interfaces";

const ReactGridLayout = WidthProvider(RGL);

type Props = {
    isActive: boolean,
    selectTemplate: Function,
    id: number | string,
    config: ITemplateConfig | null,
    gridType: number,
    switchTab?: Function | null
}

const TemplateSmall = (props: Props) => {

    const handleDoubleClick = () => {
        if (props.switchTab) {
            props.switchTab()
        } else return;
    }

    return (
        <div
			className={`template ${props.isActive ? "active" : ""}`}
         	onClick={() => props.selectTemplate(props.id, props.config)}
            onDoubleClick={handleDoubleClick}
		>
            <ReactGridLayout 
                className="layout" 
                layout={getLayout(props.gridType)} 
                cols={8} 
                rowHeight={26}
                margin={[6, 6]}
                useCSSTransforms={false}
            >
                {
                    getLayout(props.gridType).map(layout => (
                        <div className="panel" key={layout.i}></div>
                    ))
                }
            </ReactGridLayout>
            
            {
                props.isActive &&
                <div className="blue-check">
                    {check}
                </div>
             }
    </div>
    );
};

export default TemplateSmall;
